import {
  USER_LOGGEDIN,
  SET_CURRENT_USER,
  AUTHENTICATED,
  ADMINS_FETCHED,
  CURRENT_ADMIN,
  SHOW_CONFIRM_MESSAGE,
  FETCH_LOGGEDIN_USER,
  ROLES_FETCHED,
  ROLE_ADDED,
  ROLE_UPDATED,
  ROLE_DELETED
} from "../types";

const initialState = {
  user: {},
  isLoggedIn: false,
  token: null,
  isVerified: false,
  admins: [] as any,
  roles: [] as any,
  singleAdmin: {},
};

const auth = (state = initialState, action: any) => {
  switch (action.type) {
    case USER_LOGGEDIN: {
      const hasUser = action.user && typeof action.user === 'object' && Object.keys(action.user).length > 0;
      return {
        ...state,
        user: hasUser ? action.user : null,
        isLoggedIn: hasUser,
      };
    }
    case "LOGOUT": 
      return {
        ...state,
        user: null,
        isLoggedIn: false
      };
    case FETCH_LOGGEDIN_USER:
      return {
        ...state,
        user: action.user,
      };
    case AUTHENTICATED:
      return {
        ...state,
        isVerified: action.isVerified,
      };
    case SET_CURRENT_USER: {
      const hasUser = action.user && typeof action.user === 'object' && Object.keys(action.user).length > 0;
      return {
        ...state,
        user: hasUser ? action.user : null,
        isLoggedIn: hasUser,
      };
    }
    case SHOW_CONFIRM_MESSAGE:
      return {
        ...state,
        confirmMessage: action.confirmMessage,
      };
    case ADMINS_FETCHED:
      return {
        ...state,
        admins: action.admins,
      };
    case CURRENT_ADMIN:
      return {
        ...state,
        singleAdmin: action.singleAdmin,
      };
    case ROLES_FETCHED:
      return {
        ...state,
        roles: action.roles
      };
    case ROLE_ADDED:
      return {
        ...state,
        roles: [...state.roles, action.role]
      };
    case ROLE_UPDATED:
      return {
        ...state,
        roles: state.roles.map((r: any) => r.id === action.role.id ? action.role : r)
      };
    case ROLE_DELETED:
      return {
        ...state,
        roles: state.roles.filter((r: any) => r.id !== action.id)
      };
    default:
      return state;
  }
};

export default auth;



